/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs */

const en_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit the main editorial stories spanning your magazine chapters.`)
};

const es_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edita las historias editoriales principales que abarcan los capítulos de tu revista.`)
};

const fr_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiez les histoires éditoriales principales de votre magazine.`)
};

const de_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten Sie die redaktionellen Hauptgeschichten, die sich durch Ihr Magazin ziehen.`)
};

const ja_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マガジンの章にまたがる主要なエディトリアルストーリーを編集します。`)
};

const zh_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑贯穿您杂志各章节的主要社论故事。`)
};

const ar_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بتعديل القصص التحريرية الرئيسية التي تمتد عبر فصول مجلتك.`)
};

const id_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit cerita editorial utama di seluruh bab majalah Anda.`)
};

const it_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica le storie editoriali principali che attraversano i capitoli della tua rivista.`)
};

const ru_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отредактируйте основные истории, охватывающие главы вашего журнала.`)
};

const pt_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edite as principais histórias editoriais ao longo dos capítulos da sua revista.`)
};

const ko_edit_the_main_editorial_stories_spanning_your_maga = /** @type {(inputs: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잡지 챕터 전반에 걸친 주요 에디토리얼 스토리를 편집하세요.`)
};

/**
* | output |
* | --- |
* | "Edit the main editorial stories spanning your magazine chapters." |
*
* @param {Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const edit_the_main_editorial_stories_spanning_your_maga = /** @type {((inputs?: Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_The_Main_Editorial_Stories_Spanning_Your_MagaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "es") return es_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "fr") return fr_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "de") return de_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "ja") return ja_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "zh") return zh_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "ar") return ar_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "id") return id_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "it") return it_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "ru") return ru_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	if (locale === "pt") return pt_edit_the_main_editorial_stories_spanning_your_maga(inputs)
	return ko_edit_the_main_editorial_stories_spanning_your_maga(inputs)
});